/* import __COLOCATED_TEMPLATE__ from './project-details-pitch-weburl-edit-item.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

class ProjectDetailsPitchWeburlEditItem extends Component {
  @action
  onDeleteWebUrlClick() {
    const { webUrl, deleteUpdateWebUrl } = this.args;
    deleteUpdateWebUrl(webUrl);
  }

  @action
  onTextInputChange(value) {
    this.args.onWeburlLinkTextChange(value, this.args.webUrlIndex);
  }
}

export default ProjectDetailsPitchWeburlEditItem;
